<template>
  <div class="app">
    <el-container>
        <el-header height="50" style="box-shadow: 0px 2px 4px 0px rgb(175 175 175 / 20%);position:fixed;height:50px;width:100%;z-index:1;background-color:#fff;">
            <HeadBar></HeadBar>
        </el-header>
        <el-container style="margin-top:50px;">
            <el-aside width="180px" style="position:fixed;">
                <SlideBar></SlideBar>
            </el-aside>
            <div class="lmain" style="">
<!--                <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--                  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--                  <el-breadcrumb-item>活动管理</el-breadcrumb-item>-->
<!--                  <el-breadcrumb-item>活动列表</el-breadcrumb-item>-->
<!--                  <el-breadcrumb-item>活动详情</el-breadcrumb-item>-->
<!--                </el-breadcrumb>-->
              <el-breadcrumb class="app-breadcrumb" separator="/" v-if="$route.path!='/'">
                <transition-group name="breadcrumb">
                  <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
                    <span
                        v-if="item.redirect === 'noRedirect' || index == levelList.length - 1"
                        class="no-redirect"
                    >
                      {{ item.meta.title }}
                    </span>
                      <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
                    </el-breadcrumb-item>
                  </transition-group>
                </el-breadcrumb>
                <el-main class="main">
                  <div class="main-title" v-if="$route.path!='/'">{{$route.meta.title}}</div>
                  <AppMain></AppMain>
                </el-main>
            </div>
        </el-container>
    </el-container>
  </div>
</template>

<script>
import {HeadBar,SlideBar,AppMain} from './components'
const pathToRegexp = require('path-to-regexp');
export default {
    components:{
        HeadBar,
        SlideBar,
        AppMain
    },
  data() {
    return {
      access_deny:false,
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods:{
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(
          item => item.meta && item.meta.title
      )
      const first = matched[0]

      if (!this.isDashboard(first)) {
        matched = [{ path: '/dashboard', meta: { title: '工作台' }}].concat(
            matched
        )
      }

      this.levelList = matched.filter(
          item => item.meta && item.meta.title && item.meta.breadcrumb !== false
      )

    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>
<style scoped>
.lmain{
  width:100%;
  height:calc(100vh - 101px);
  padding-left:180px;
}
</style>